// The filter bar's two responsive breaks. It measures the bar itself (container queries), not the
// window, because the investigations rail takes a variable share of the width. Tailwind reads the
// classes as literals, so the breakpoints are spelt out in each string rather than interpolated.
//
// Compact: below this the named buttons drop to icon only (the label stays for screen readers) so
// the bar holds one line, and the thumbnail size slider folds into a menu.
export const FILTER_BAR_COMPACT_LABEL = '@max-[1200px]:sr-only';
export const FILTER_BAR_COMPACT_HIDDEN = '@max-[1200px]:hidden';
export const FILTER_BAR_FULL_ONLY = '@max-[1200px]:hidden';
export const FILTER_BAR_COMPACT_ONLY = 'hidden @max-[1200px]:inline-flex';

// Narrow: below this the search folds into a button that swaps the bar for a full-width box.
export const FILTER_BAR_NARROW_SEARCH_INPUT = '@max-[750px]:hidden';
export const FILTER_BAR_NARROW_SEARCH_BUTTON = 'hidden @max-[750px]:inline-flex';
export const FILTER_BAR_NARROW_SEARCH_OPEN =
  'hidden @max-[750px]:group-data-[search-open]/bar:flex';
export const FILTER_BAR_NARROW_HIDE_WHEN_SEARCH_OPEN =
  '@max-[750px]:group-data-[search-open]/bar:hidden';

// The investigation header above the bar: below this its Refresh, Schedule and Share buttons move
// into the More actions menu so the title isn't squeezed. A menu is portalled out of the header, so
// this one is measured in script (useBelowWidth) rather than by a container query.
export const INVESTIGATION_HEADER_COMPACT_BELOW = 1000;
